import { useEffect, useRef, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const START_SECONDS = 17 * 60 + 34; // 00:17:34 (mm:ss)

function pad(n: number) {
  return n.toString().padStart(2, '0');
}

/**
 * Countdown that starts at 00:17:34 and auto-restarts when it hits zero.
 * `variant="bar"` shows an amber pill; `variant="inline"` is compact for the floating button.
 */
export function Countdown({
  variant = 'bar'
}: {
  variant?: 'bar' | 'inline';
}) {
  const [remaining, setRemaining] = useState(START_SECONDS);
  const ref = useRef<number | null>(null);
  useEffect(() => {
    ref.current = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => {
      if (ref.current) window.clearInterval(ref.current);
    };
  }, []);
  const hh = Math.floor(remaining / 3600);
  const mm = Math.floor(remaining % 3600 / 60);
  const ss = remaining % 60;
  if (variant === 'inline') {
    return <span className="tabular-nums font-cond font-semibold" data-id="element-170" data-mp="159bwvlkgps2q">
        {pad(hh)}:{pad(mm)}:{pad(ss)}
      </span>;
  }
  const blocks = [{
    v: hh,
    l: 'HRS'
  }, {
    v: mm,
    l: 'MIN'
  }, {
    v: ss,
    l: 'SEG'
  }];
  return <div className="flex flex-col items-center gap-2" data-id="element-171" data-mp="17rhqf11eimzp">
      <div className="flex items-center gap-1.5 text-amber-400 text-xs font-cond font-semibold uppercase tracking-wider" data-id="element-172" data-mp="17q6pra395vct">
        <ClockIcon className="h-3.5 w-3.5" data-id="element-173" data-mp="f2aso49ru1fi" />
        La oferta termina en
      </div>
      <div className="flex items-center gap-2" data-id="element-174" data-mp="f4ewkm7o70fs">
        {blocks.map((b, i) => <div key={b.l} className="flex items-center gap-2" data-id="element-175" data-mp="a528jy52bnbm" data-mpi={i}>
            <div className="flex flex-col items-center rounded-lg bg-[#1b1b20] border border-amber-500/30 px-3 py-2 min-w-[58px]" data-id="element-176" data-mp="o38womk7m8y3">
              <span className="font-display text-3xl leading-none text-white tabular-nums" data-id="element-177" data-mp="k03wwrrikld5">
                {pad(b.v)}
              </span>
              <span className="text-[10px] font-cond tracking-widest text-neutral-400 mt-1" data-id="element-178" data-mp="1vgu86paso3dm">
                {b.l}
              </span>
            </div>
            {i < blocks.length - 1 && <span className="font-display text-2xl text-amber-500" data-id="element-179" data-mp="x4rbffvx13w6">:</span>}
          </div>)}
      </div>
    </div>;
}